module.exports = __webpack_public_path__ + "static/toggl-track-558d754e7a2d87ec20c2167ef8181f0f.mp4";